export const STORAGE_KEYS = {
  settings: {
    locale: "athkari.lang",
    theme: "athkari.theme",
    accent: "athkari.accent",
    visualStyle: "athkari.visualStyle",
    textSize: "athkari.textSize",
    motion: "athkari.motion",
    athkarFont: "athkari.athkarFont",
    lightweight: "athkari.lightweight",
    sounds: "athkari.sounds",
    notifications: "athkari.notifications",
    hijriOffset: "athkari.hijriOffset",
    prayerSource: "athkari.prayerSource",
    calcMethod: "athkari.calcMethod"
  },
  athkarProgress: "athkari.athkar.progress.v3",
  athkarFavorites: "athkari.athkar.favorites.v3",
  athkarDefaultFavoritesSeeded: "athkari.athkar.defaultFavoritesSeeded.v1",
  quranLastRead: "athkari.quran.lastRead.v1",
  quranBookmarks: "athkari.quran.bookmarks.v1",
  tasbeehCount: "athkari.tasbeeh.count.v1",
  tasbeehPreset: "athkari.tasbeeh.preset.v1",
  tasbeehTarget: "athkari.tasbeeh.target.v1",
  prayerLocation: "athkari.prayer.location.v1",
  prayerSettings: "athkari.prayer.settings.v1",
  manasikReviewed: "athkari.manasik.reviewed.v1"
} as const;
